import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Typography, Tabs, Tab } from '@mui/material';
import SPDInfo from './SPDInfo';
import SPDLeadership from './SPDLeadership';
import SPDCommittees from './SPDCommittees';
import SPDGroupsReciprocities from './SPDGroupsRecipro';
import SPDResources from './SPDResources';
import { useApiGet } from '../../../utils/httpClient';
import { getSpdDetail } from '../../../endpoints/chapters';

const SPDDetail = () => {
  let { id } = useParams();
  const [tabSelected, setTabSelected] = useState(0);

  const { data, isFetching } = useApiGet(
    ['spd-chapters-detail', id],
    getSpdDetail,
    {
      enabled: true,
      retry: 1,
    },
    {
      id: id,
    }
  );
  return (
    <Grid container>
      <Grid item xs={12} padding textAlign={'center'}>
        <Typography variant="h4">{data?.name}</Typography>
      </Grid>
      <Grid item xs={12} padding>
        <Tabs
          value={tabSelected}
          onChange={(event, newValue) => setTabSelected(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Chapter Info" />
          <Tab label="Chapter Leadership" />
          <Tab label="Chapter Committees" />
          <Tab label="Groups and Reciprocities" />
          {data?.spd_access && <Tab label="Resources" />}
        </Tabs>
      </Grid>
      <Grid item xs={12} padding>
        {tabSelected === 0 && <SPDInfo id={id} spdAccess={data?.spd_access} />}
        {tabSelected === 1 && (
          <SPDLeadership id={id} spdAccess={data?.spd_access} />
        )}
        {tabSelected === 2 && (
          <SPDCommittees id={id} spdAccess={data?.spd_access} />
        )}
        {tabSelected === 3 && (
          <SPDGroupsReciprocities id={id} spdAccess={data?.spd_access} />
        )}
        {data?.spd_access && tabSelected === 4 && <SPDResources id={id} />}
      </Grid>
    </Grid>
  );
};

export default SPDDetail;
